import type { IUseGetSocialOfferPrescriptionFilledResponse } from "@api";
import { Typography } from "@mui/material";
import type { IPopoverState } from "../index";

interface IAccompaniement {
  accompaniement: string;
  otherIntegratedSocialOffers: IUseGetSocialOfferPrescriptionFilledResponse["otherIntegratedSocialOffers"];
  setAccompaniementPopoverState: (state: IPopoverState) => void;
}
export const Accompaniement = ({
  otherIntegratedSocialOffers,
  accompaniement,
  setAccompaniementPopoverState,
}: IAccompaniement) => {
  return otherIntegratedSocialOffers.length > 0 ? (
    <Typography
      variant="body1SemiBold"
      sx={{ cursor: "pointer", color: "primary.main", textDecoration: "underline" }}
      onClick={(e) =>
        setAccompaniementPopoverState({ anchorEl: e.currentTarget, otherIntegratedSocialOffers, accompaniement })
      }
    >
      {accompaniement} (+{otherIntegratedSocialOffers.length})
    </Typography>
  ) : (
    <Typography variant="body1">{accompaniement}</Typography>
  );
};
